module.exports = __webpack_public_path__ + "assets/img/block-left-hover-f2f4e4e6.png";